angular.module("BB")

.constant("bbConfig", {
    "BUILD": {
        "APP_NAME": "family-hubs-events",
        "CACHE_CONTROL_MAX_AGE": "10",
        "DEFAULT_HTML": "/",
        "DEPLOY_VERSION": false,
        "DISTRIBUTION_CHUNK_HASH": false,
        "SERVER_PORT": 8000,
        "SHOW_VERSION": true,
        "UGLIFY": false,
        "DEPLOY_PATH": "/family-hubs-events/staging/",
        "ROOT": "src\\public",
        "SDK_VERSION": "git+https://user@github.com/bookinglab/bl-bookingbug-dependancies.git#BB-3.9.10-westberkshire-unique",
        "BUILD_DATETIME": "May 12, 2023 12:40 PM "
    },
    "CORE": {
        "GOOGLE_MAPS_KEY": "AIzaSyCJoc-PdYfUtB74S6_sSxJknWF5sBmw1AQ",
        "ANALYTICS": {
            "ENABLE_PIWIK": false
        },
        "API_URL": "https://bookinglab-demo.bookingbug.com/",
        "COMPANY_ID": "37157",
        "FAMILY_HUB_ID": "37157"
    }
})

;


// WEBPACK FOOTER //
// tmp/config.constants.js